import { render, staticRenderFns } from "./monitorDetail.vue?vue&type=template&id=6b841f39&scoped=true"
import script from "./monitorDetail.vue?vue&type=script&lang=js"
export * from "./monitorDetail.vue?vue&type=script&lang=js"
import style0 from "./monitorDetail.vue?vue&type=style&index=0&id=6b841f39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b841f39",
  null
  
)

export default component.exports